import { Link, useRouteError } from "react-router-dom";
import "../CSS/Error.css";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  // Fallback values if error properties are undefined
  const status = error?.status || "Unknown Error";
  const statusText = error?.statusText || "An unexpected error occurred";
  const message = status === 404 
    ? "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."
    : "Check your Internet";
    return (
    <div className="ErrorPage">
      <HelmetProvider>
        <Helmet>
          <title>Error - BlogWiki</title>
          <meta
            name="description"
            content="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."
          />
        </Helmet>
      </HelmetProvider>
      <div className="OopsStyple">
        <h1 className="ErrroHeading">Oops!</h1>
      </div>
      <div className="Errormessage">
        {status ? <h2>{status}-{statusText}<p>{message}</p></h2> :""}
        {
          status === 404 ?(<button className="LinkButton">
          <Link to="/" className="LinkText">
            GO TO HOMEPAGE
          </Link>
        </button>) :("")
        }
      </div>
    </div>
  );
}
